'use client'

import { createContext, useContext } from 'react'

/**
 * テナントのデフォルトCTAボタン色（不透明HEX / 未設定なら null）を
 * ツリー全体へ配る Context。CTAボタン（ctaUrl 由来の「採用情報へ」等）が
 * 深いネスト越しにテナント色を参照できるようにするために使う。
 *
 * 埋め込み（EmbeddingAiInterviewPresentation）と動画詳細ページ（VideoDetailClient）で
 * Provider を張り、各CTAボタンが useTenantButtonColor() で読む。
 */
const TenantButtonColorContext = createContext<string | null>(null)

export const TenantButtonColorProvider = TenantButtonColorContext.Provider

export function useTenantButtonColor(): string | null {
  return useContext(TenantButtonColorContext)
}
